import {useMamInformation} from "../../contexts/MamInformation";
import {useMamSummary} from "../../contexts/mamSummary";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {useTheme} from "../../contexts/theme";
import {Typography} from "@mui/material";
import {useEffect, useState} from "react";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MatchContainer from "./MatchContainer";
import {formatUTCDate} from "../../utils/dateTimeutils";
import {MatchDays} from "../../types/mamTypes";
import MatchDaysMamSkeleton from "./MamSkeleton/MatchDaysMamSkeleton";

interface MatchDayProps {
    matchDay: MatchDays;
    onCollapseOpen: (matchDay_id: string, openMatchDay: boolean) => void;
    collapseOpen: boolean;
    loading: boolean
}


export default function MatchDay({matchDay, onCollapseOpen, collapseOpen, loading}: MatchDayProps) {
    const theme = useTheme();

    const handleShowMatch = () => {

        onCollapseOpen(matchDay.id, collapseOpen);
    }


    return (
        <Grid item xs={12} >
            <Box
                display={'flex'}
                alignItems={'center'}
                justifyContent={'space-between'}
                height={'50px'}
                onClick={() => handleShowMatch()}
                sx={{
                    backgroundColor: theme.palette.blurredBlue,
                    borderBottom: `${theme.border.type.solid} ${theme.border.width.medium} ${theme.palette.white}`,
                    borderTop: matchDay.matchday === 0 ? `${theme.border.type.solid} ${theme.border.width.medium} ${theme.palette.white}` : ''
                }}
            >
                <Grid container spacing={2}>
                    <Grid item xs={12} md={4} sx={{ display: 'flex', alignItems: 'start', justifyContent: 'start' }}>
                        <Typography
                    variant="subtitle1"
                    sx={{
                        fontWeight: theme.fontWeights.title,
                        color: theme.palette.white,
                        marginBottom: theme.spacing.xs,
                        borderBottom: `${theme.border.width} ${theme.border.type} ${theme.palette.white}`
                    }}
                >
                    {matchDay.matchday > -1 ? (matchDay.roundType ? matchDay.roundType : "Match day ") + " " + matchDay.matchday : "No match day info"}
                </Typography>
                    </Grid>
                    <Grid item xs={12} md={4} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography
                    variant="subtitle1"
                    sx={{
                        fontWeight: theme.fontWeights.title,
                        color: theme.palette.white,
                        marginBottom: theme.spacing.xs,
                        borderBottom: `${theme.border.width} ${theme.border.type} ${theme.palette.white}`
                    }}
                >
                    {matchDay.matchday > -1 && matchDay.start
                        ? `${formatUTCDate(matchDay.start!.toString(), false, false)} / ${formatUTCDate(matchDay.end!.toString(), false, false)}`
                        : ""}
                </Typography>
                    </Grid>
                    <Grid item xs={12} md={4} sx={{ display: 'flex', alignItems: 'end', justifyContent: 'end' }}>
                {collapseOpen ? <ArrowDropUpIcon/> : <ArrowDropDownIcon/>}
                </Grid>
                </Grid>
            </Box>

            {collapseOpen &&
                <MatchContainer matchDay={matchDay} loading={loading}  />

            }


                    </Grid>
    );
}